<template>
  <nav v-if="totalPages > 1" class="data-table-pagination" aria-label="Navigasi halaman tabel">
    <span class="data-table-pagination__summary">{{ startRow }}-{{ endRow }} dari {{ totalRows }} data</span>
    <button type="button" :disabled="page <= 1" aria-label="Halaman sebelumnya" @click="changePage(page - 1)">
      <i class="fas fa-chevron-left" aria-hidden="true"></i>
    </button>
    <template v-for="item in visiblePages">
      <span v-if="item.type === 'ellipsis'" :key="item.key" class="data-table-pagination__ellipsis" aria-hidden="true">...</span>
      <button
        v-else
        :key="item.key"
        type="button"
        :class="{ 'data-table-pagination__current': item.page === page }"
        :aria-label="`Halaman ${item.page}`"
        :aria-current="item.page === page ? 'page' : null"
        @click="changePage(item.page)"
      >{{ item.page }}</button>
    </template>
    <button type="button" :disabled="page >= totalPages" aria-label="Halaman berikutnya" @click="changePage(page + 1)">
      <i class="fas fa-chevron-right" aria-hidden="true"></i>
    </button>
  </nav>
</template>

<script>
export default {
  name: "DataTablePagination",
  props: {
    page: { type: Number, default: 1 },
    totalRows: { type: Number, default: 0 },
    perPage: { type: Number, default: 20 },
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.totalRows / this.perPage))
    },
    startRow() {
      return this.totalRows === 0 ? 0 : ((this.page - 1) * this.perPage) + 1
    },
    endRow() {
      return Math.min(this.page * this.perPage, this.totalRows)
    },
    visiblePages() {
      const pages = []
      const candidates = [1, this.page - 1, this.page, this.page + 1, this.totalPages]
        .filter((value) => value >= 1 && value <= this.totalPages)
        .filter((value, index, values) => values.indexOf(value) === index)
        .sort((a, b) => a - b)

      candidates.forEach((candidate, index) => {
        if (index > 0 && candidate - candidates[index - 1] > 1) {
          pages.push({ type: "ellipsis", key: `ellipsis-${candidate}` })
        }
        pages.push({ type: "page", page: candidate, key: `page-${candidate}` })
      })

      return pages
    },
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.totalPages || page === this.page) return
      this.$emit("change", page)
    },
  },
}
</script>

<style lang="scss" scoped>
.data-table-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.9rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  color: #475569;
  font-size: 0.78rem;
}

.data-table-pagination button,
.data-table-pagination__current {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  border: 1px solid #dce4ec;
  border-radius: 8px;
  background: #f8fafc;
  color: #475569;
}

.data-table-pagination button:disabled { opacity: 0.42; cursor: not-allowed; }
.data-table-pagination__current { border-color: var(--skin-primary); background: var(--skin-primary); color: #fff; font-weight: 700; }
.data-table-pagination__summary { margin-right: auto; color: #64748b; font-weight: 600; }
.data-table-pagination__ellipsis { display: inline-flex; align-items: center; justify-content: center; width: 22px; color: #94a3b8; }

@media (max-width: 575.98px) {
  .data-table-pagination { justify-content: center; flex-wrap: wrap; }
  .data-table-pagination__summary { width: 100%; text-align: center; }
}
</style>
